<template lang="pug">
  .settings-table-container(@click="hideSettings")
    .settings-table.relative(@click.stop="")
      img.times-icon(:src="require('@/assets/times.svg')" alt="close" @click="hideSettings")
      .settings-title Ordenar Campos
      draggable.settings-table-header(v-model="fields" :options="{ group: 'fields', handle: '.settings-table-move' }")
        .settings-table-header-item(v-for="(field, index) in fields" :key="field.name")
          .settings-table-move
            img(:src="require('@/assets/move.svg')" alt="move")
          .settings-table-header-text.tag(:class="{ 'active': field.show }" @click="field.show = !field.show") {{ field.label }}
          .settings-divider(:class="{ 'active': field.divider }" @click="field.divider = !field.divider")

      .settings-actions
        shActionButton(text="Restaurar" :action="resetFields")
        shActionButton(text="Guardar" :action="saveFields")
</template>

<script>
import draggable from 'vuedraggable'
import shActionButton from '@/components/elements/ActionButton'

export default {
  name: 'SettingsTable',

  components: { draggable, shActionButton },

  data () {
    return {
      fields: []
    }
  },

  mounted () {
    this.fields = JSON.parse(JSON.stringify(this.$store.state.interface.fieldsOrder))
  },

  methods: {
    saveFields () {
      this.$store.commit('setFieldsOrder', JSON.parse(JSON.stringify(this.fields)))
      this.$store.commit('hideSettings')
    },
    hideSettings () {
      this.$store.commit('hideSettings')
    },
    resetFields () {
      this.$store.commit('resetFieldsOrder')
      this.fields = JSON.parse(JSON.stringify(this.$store.state.interface.fieldsOrder))
    }
  },

  computed: {
    fieldsOrder () {
      return this.$store.state.interface.fieldsOrder
    }
  }
}
</script>

<style lang="stylus" scoped>
.settings-table-container
  position fixed
  top 0
  left 0
  width 100%
  height 100%
  background-color rgba(0, 0, 0, 0.5)
  z-index 1000
  display flex
  justify-content center
  align-items center
  font-size 1.2rem

.settings-table
  width 90%
  max-width 50rem
  background-color white
  border-radius 10px
  padding 20px

.settings-table-header
  display flex
  gap 1em 2em
  align-items center
  flex-wrap wrap
  margin-bottom 2rem

.settings-table-header-item
  display flex
  align-items center
  gap .3em

.settings-table-header-text
  opacity 0.5
  transition opacity 0.3s ease

.settings-table-header-text.active
  opacity 1
  border 1px solid gray

.settings-title
  font-size 1.2rem
  font-weight 600
  margin-bottom 2rem

.settings-divider
  display flex
  align-items center
  width 2.5rem
  height 1em

.settings-divider:before
  content ''
  display block
  width 100%
  height 100%
  opacity 0.8
  background-color #e9e9e7
  border-radius .2rem

.settings-divider.active:before
  opacity 1
  border 1px solid gray

.times-icon
  position absolute
  top 1rem
  right 1rem
  cursor pointer
  height 1.5rem
  width 1.5rem

.settings-actions
  display flex
  gap 1rem
  justify-content center

.settings-table-move
  cursor grab
  height 1.5rem
  width 1.5rem
</style>



// WEBPACK FOOTER //
// src/components/global/SettingsTable.vue